var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserHelmetSafety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 320C289.25 320 342.5 271 350.375 208H97.625C105.5 271 158.75 320 224 320ZM88 176H360C364.375 176 368 172.375 368 168V136C368 131.625 364.375 128 360 128H352C352 83 325.125 42.375 283.625 24.75L256 80V16C256 7.125 248.875 0 240 0H208C199.125 0 192 7.125 192 16V80L164.375 24.75C122.875 42.375 96 83 96 128H88C83.625 128 80 131.625 80 136V168C80 172.375 83.625 176 88 176ZM314.664 352H133.336C59.699 352 0 411.695 0 485.332C0 500.059 11.941 512 26.664 512H421.336C436.059 512 448 500.059 448 485.332C448 411.695 388.307 352 314.664 352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHelmetSafety);
export default __webpack_public_path__ + "static/media/user-helmet-safety.88469182578044c092b62c01438730e5.svg";
export { ForwardRef as ReactComponent };